/* eslint-disable */
import React, { useState } from "react";

const AgendaListFilter = ({ tagList, setfilterTags, searchHandler }) => {
  const [tagValues, settagValues] = useState([]);

  const [fromDate, setfromDate] = useState("");
  const [toDate, settoDate] = useState("");

  //function for select event tags
  const tagSelectionHandler = (data) => {
    let prevTagValues = tagValues;

    if (prevTagValues.includes(data.value)) {
      let selectedItem = document.getElementById("filtertagli-" + data.value);

      selectedItem.classList.remove("active");

      // exist in array, thus remove
      let key = prevTagValues.indexOf(data.value);
      prevTagValues.splice(key, 1);
    } else {
      let selectedItem = document.getElementById("filtertagli-" + data.value);

      selectedItem.classList.add("active");
      // not exist in array, thus add
      prevTagValues.push(data.value);
    }

    settagValues(prevTagValues);
  };

  //function for remove active class for selected tags
  const removeActiveClass = () => {
    const liElements = document.querySelectorAll(".filtertagstyle");

    liElements.forEach((li) => {
      li.classList.remove("active");
    });
  };

  //function for assign search data for filter and close pop up
  const searchDataHandler = () => {
    //check start date and end date are not empty.If end date empty then only search by start date
    // if (fromDate != "" && toDate != "" && fromDate < toDate) {
    //   setFilterDateRange(fromDate + "," + toDate);
    // } else if (fromDate != "") {
    //   setFilterDateRange(fromDate);
    // }

    // setfilterTags(tagValues);

    searchHandler(fromDate);

    // close the offcanvas of filter
    let offCanvasPopup = document.querySelector("#offcanvasAgenda");
    let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
    offCanvas.hide();
    resetHandler();
  };

  //function for reset search
  const resetHandler = () => {
    removeActiveClass();
    setfromDate("");
    settagValues([]);
  };

  return (
    <div className="offcanvas_sidebar">
      <div
        className="offcanvas offcanvas-end body_bg"
        tabIndex="-1"
        id="offcanvasAgenda"
        aria-labelledby="offcanvasAgenda"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="close-btn text-reset filter_cross d-flex align-items-center justify-content-center"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <span className="material-icons-outlined">close</span>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="filter_outerbx">
            {/* tags */}
            {/* <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Tags</h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>

              <div className="filter_info">
                <div className="filter_list department_info">
                  <ul className="list_style_none d-flex gap-2 flex-wrap">
                    {tagList.map((tag, index) => {
                      return (
                        <li
                          key={index}
                          id={"filtertagli-" + tag.value}
                          onClick={() => {
                            tagSelectionHandler(tag);
                          }}
                          className="filtertagstyle"
                        >
                          {tag.label}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div> */}

            {/* <li className="active">All Sector</li> */}

            {/* <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Created </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="price_range d-flex gap-2">
                <div className="price_fill">
                  <input
                    type="date"
                    value=""
                    className="form-control"
                    placeholder="From"
                  />
                </div>
                <div className="price_fill">
                  <input
                    type="date"
                    value=""
                    className="form-control "
                    placeholder="To"
                  />
                </div>
                <div className="go_btn">
                  <input
                    type="submit"
                    value="Go"
                    className="go_price btn primary-btn"
                  />
                </div>
              </div>
            </div> */}
          </div>

          <div className="product_filtr_item mb-3">
            <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
              <div className="filter_name">
                <h4 className="fs-sm fw-medium text-primary">
                  Search by Date{" "}
                </h4>
              </div>
              <span className="accor_arw">
                <i className="material-icons-outlined"> keyboard_arrow_down</i>
              </span>
            </div>
            <div className="price_range d-flex gap-2">
              <div className="price_fill">
                <input
                  type="date"
                  className="form-control"
                  placeholder="From"
                  value={fromDate}
                  onChange={(e) => setfromDate(e.target.value)}
                />
              </div>
              <button
                type="button"
                className="btn primary-btn fs-sm fw-normal w-100"
                onClick={searchDataHandler}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgendaListFilter;
